import { render, staticRenderFns } from "./ProductSlider.vue?vue&type=template&id=16f26b89&scoped=true"
import script from "@/components/product-slider/ProductSlider.ts?vue&type=script&lang=ts&external"
export * from "@/components/product-slider/ProductSlider.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/product-slider/product-slider.scss?vue&type=style&index=0&id=16f26b89&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f26b89",
  null
  
)

export default component.exports